export const INT_AD_PERFORMANCE_TAB_CLICKED = "INT_AD_PERFORMANCE_TAB_CLICKED";
export const INT_SMART_ADS_SIDEBAR_ICON_CLICKED =
  "INT_SMART_ADS_SIDEBAR_ICON_CLICKED";
